import React, { SVGProps } from 'react'

const PaginationActiveDotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={9}
    fill="none"
    aria-hidden
    {...props}
  >
    <circle cx={4.5} cy={4.5} r={4.5} fill="#3B3B3B" />
  </svg>
)
export default PaginationActiveDotIcon
